import { observer } from 'mobx-react'
import { FC } from 'react'

import { RadioBasedField } from '@new/__global/components/Filters'
import {
  FiltersProps,
  QuickFilterOptions,
} from '@new/domains/operations/screens/CasesV2/CasesV2.types'

const preDefinedOptions = [
  { title: 'All cases', value: QuickFilterOptions.all, id: QuickFilterOptions.all },
  { title: 'Overdue', value: QuickFilterOptions.overdue, id: QuickFilterOptions.overdue },
  {
    title: 'Assigned To Me',
    value: QuickFilterOptions.assignedToMe,
    id: QuickFilterOptions.assignedToMe,
  },
  {
    title: 'Created By Me',
    value: QuickFilterOptions.createdByMe,
    id: QuickFilterOptions.createdByMe,
  },
  {
    title: 'Created By Cleaners',
    value: QuickFilterOptions.createdByCleaner,
    id: QuickFilterOptions.createdByCleaner,
  },
  {
    title: 'Closed: Last Day',
    value: QuickFilterOptions.closedLastDay,
    id: QuickFilterOptions.closedLastDay,
  },
  {
    title: 'Closed: Last 3 Days',
    value: QuickFilterOptions.closedLastThreeDays,
    id: QuickFilterOptions.closedLastThreeDays,
  },
  {
    title: 'Closed: Last Week',
    value: QuickFilterOptions.closedLastWeek,
    id: QuickFilterOptions.closedLastWeek,
  },
  {
    title: 'Closed: Last 2 Weeks',
    value: QuickFilterOptions.closedLastTwoWeeks,
    id: QuickFilterOptions.closedLastTwoWeeks,
  },
  {
    title: 'Closed: Last Month',
    value: QuickFilterOptions.closedLastMonth,
    id: QuickFilterOptions.closedLastMonth,
  },
]

interface QuickFilterProps extends FiltersProps {
  initialValue?: QuickFilterOptions
  onChange: (value?: QuickFilterOptions) => void
}
const _QuickFilter: FC<QuickFilterProps> = ({ onChange, initialValue, ...otherProps }) => {
  return (
    <RadioBasedField
      title="Quick Views"
      radioGroupId="preDefinedQuickFilter"
      options={preDefinedOptions}
      initialValue={initialValue}
      defaultValue={QuickFilterOptions.all}
      isSidebarFilter
      shouldShowClearButton={false}
      onChange={onChange}
      {...otherProps}
    />
  )
}

export const QuickFilter = observer(_QuickFilter)
